import { motion } from "framer-motion";
import { reveal, revealContainer, viewportOnce } from "../../lib/motion";

const SERVICES = [
  { title: "Corporate Catering", desc: "Impress clients and reward teams with refined Japanese spreads." },
  { title: "Office Lunches", desc: "Freshly delivered bento and platters for the whole floor." },
  { title: "Business Meetings", desc: "Elegant, easy-to-serve food that keeps the room focused." },
  { title: "Private Parties", desc: "A memorable centrepiece for gatherings at home." },
  { title: "Birthday Catering", desc: "Celebrate with colourful, handmade Japanese favourites." },
  { title: "Community Events", desc: "Generous platters that bring people together." },
  { title: "School Functions", desc: "Wholesome, crowd-pleasing menus for every age." },
  { title: "Special Occasions", desc: "Bespoke catering tailored to your milestone moment." },
];

export const Services = () => (
  <section id="services" data-testid="services-section" className="bg-charcoal py-24 md:py-32">
    <div className="mx-auto max-w-[1400px] px-6 md:px-10">
      <div className="max-w-2xl mb-16">
        <span className="label-caps text-gold">Catering Services</span>
        <h2 className="mt-4 font-serif text-4xl md:text-5xl lg:text-6xl text-cream leading-[1.05]">
          Catering for every kind of gathering
        </h2>
      </div>

      <motion.div
        variants={revealContainer}
        initial="hidden"
        whileInView="show"
        viewport={viewportOnce}
        className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-px bg-cream/10 border border-cream/10"
      >
        {SERVICES.map((s, i) => (
          <motion.div
            key={i}
            variants={reveal}
            data-testid={`service-card-${i}`}
            className="bg-charcoal p-8 min-h-[220px] flex flex-col justify-between hover:bg-sage/20 transition-colors duration-300"
          >
            <span className="font-serif text-2xl text-gold">0{i + 1}</span>
            <div>
              <h3 className="font-serif text-2xl text-cream mb-2">{s.title}</h3>
              <p className="text-cream/55 text-sm leading-relaxed">{s.desc}</p>
            </div>
          </motion.div>
        ))}
      </motion.div>
    </div>
  </section>
);
